// @core/api/endpoints/apikey/get_api_key_usage_history.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyUsageHistoryResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Get API key usage history
 * Returns time-series usage data for an API key with configurable granularity. Useful for visualizing usage trends and identifying patterns.
 */
export async function GetAPIKeyUsageHistory(
  key_id: string,
  options?: RequestOptions
): Promise<APIKeyUsageHistoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/usage/history`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.get<APIKeyUsageHistoryResponse>(requestPath, { ...requestOptions });
}
